"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSpellCategory = exports.staticSpellSchema = exports.spellVariablesMapSchema = exports.spellVariablesInnerMapSchema = exports.spellVariableNameSchema = exports.spellVariablesSchema = exports.spellRoleSchema = exports.spellRoleList = exports.spellCategorySchema = exports.spellCategoryList = exports.spellIdSchema = void 0;
var joi = __importStar(require("joi"));
var inferFn_1 = require("../utils/inferFn");
var object_1 = require("../utils/object");
var character_basics_1 = require("./character-basics");
exports.spellIdSchema = joi.string().required().min(1);
exports.spellCategoryList = ['offensive', 'support', 'placement'];
exports.spellCategorySchema = exports.spellCategoryList;
var spellRoleMap = inferFn_1.inferFn()({
    'simpleAttack': 'offensive',
    'move': 'placement',
    'sword-sting': 'offensive',
    'side-attack': 'offensive',
    'blood-sharing': 'support',
    'switch': 'placement',
    'treacherous-blow': 'offensive',
    'attraction': 'placement',
    'distraction': 'placement',
    'slump': 'offensive',
    'last-resort': 'offensive',
    'motivation': 'support'
});
exports.spellRoleList = object_1.ObjectTyped.keys(spellRoleMap);
exports.spellRoleSchema = exports.spellRoleList;
var spellvariablesSchemaContent = {
    duration: joi.number().required().integer().min(0),
    lineOfSight: joi.boolean().required(),
    rangeArea: joi.number().required().integer().min(0),
    actionArea: joi.number().required().integer().min(0),
    attack: joi.number().required().integer()
};
exports.spellVariablesSchema = joi.object(spellvariablesSchemaContent);
exports.spellVariableNameSchema = object_1.ObjectTyped.keys(spellvariablesSchemaContent);
exports.spellVariablesInnerMapSchema = joi.object({})
    .pattern(exports.spellIdSchema, joi.any());
exports.spellVariablesMapSchema = joi.object({})
    .pattern(exports.spellVariableNameSchema, exports.spellVariablesInnerMapSchema);
exports.staticSpellSchema = joi.object({
    spellId: exports.spellIdSchema,
    characterId: character_basics_1.characterIdSchema,
    spellRole: exports.spellRoleSchema
});
var getSpellCategory = function (spellRole) { return spellRoleMap[spellRole]; };
exports.getSpellCategory = getSpellCategory;
